import React, { MouseEvent, useEffect, useState } from "react";

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition >= 350);
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`td_scrollup ${isVisible ? "td_scrollup_show" : ""}`}
      onClick={scrollToTop}
      style={{
        marginBottom:
          window.location.pathname === "/application-form" ? "60px" : "0px",
      }}
    >
      <i className="fa-solid fa-arrow-up"></i>
    </div>
  );
};
